
// SVG Icon: pulling-away-layers
export default { id: "terriajs-pulling-away-layers" };
export const id = "terriajs-pulling-away-layers";
export const name = "pulling-away-layers";
